const tidalColorsDark = {
  cloudGray: {
    "50": "#07080A",
    "100": "#0E1013",
    "200": "#1A1E23",
    "300": "#2A323B",
    A400: "#EAEEF2",
    A500: "#F3F5F7",
    A600: "#F9FAFB",
    A700: "#FFFFFF"
  },
  deepPurple: {
    "50": "#311B92",
    "100": "#4527A0",
    "200": "#512DA8",
    "300": "#5E35B1",
    "400": "#673AB7",
    "500": "#7E57C2",
    "600": "#9575CD",
    "700": "#B39DDB",
    "800": "#D1C4E9",
    "900": "#EDE7F6",
    A100: "#6200EA",
    A200: "#651FFF",
    A400: "#7C4DFF",
    A700: "#B388FF"
  },
  jadeGreen: {
    "50": "#143324",
    "100": "#276547",
    "200": "#31805B",
    "300": "#41A776",
    "400": "#47B882",
    "500": "#6BC69B",
    "600": "#8AD1AF",
    "700": "#ABDEC6",
    "800": "#DCF2E7",
    "900": "#EDF8F3"
  },
  lightGreen: {
    "50": "#33691E",
    "100": "#558B2F",
    "200": "#689F38",
    "300": "#7CB342",
    "400": "#8BC34A",
    "500": "#A6CB72",
    "600": "#AED581",
    "700": "#C5E1A5",
    "800": "#DCEDC8",
    "900": "#F1F8E9",
    A100: "#64DD17",
    A200: "#76FF03",
    A400: "#B2FF59",
    A700: "#CCFF90"
  },
  lobsterRed: {
    "50": "#3C1009",
    "100": "#621B0E",
    "200": "#892614",
    "300": "#A62E18",
    "400": "#D63B1F",
    "500": "#F1674F",
    "600": "#E58270",
    "700": "#ECA598",
    "800": "#F7DAD5",
    "900": "#FBECE9"
  },
  oceanBlue: {
    "50": "#061C35",
    "100": "#002D5C",
    "200": "#0E4686",
    "300": "#11539D",
    "400": "#1565C0",
    "500": "#4383CC",
    "600": "#699DD7",
    "700": "#A1C1E6",
    "800": "#D4E3F3",
    "900": "#E1EBF7",
    A100: "#2B6AB2",
    A200: "#3E98FF",
    A700: "#64ACFF"
  },
  pink: {
    "50": "#880E4F",
    "100": "#AD1457",
    "200": "#C2185B",
    "300": "#D81B60",
    "400": "#E91E63",
    "500": "#EC407A",
    "600": "#F06292",
    "700": "#F48FB1",
    "800": "#F8BBD0",
    "900": "#FCE4EC",
    A100: "#C51162",
    A200: "#F50057",
    A400: "#FF4081",
    A700: "#FF80AB"
  },
  purple: {
    "50": "#4A148C",
    "100": "#6A1B9A",
    "200": "#7B1FA2",
    "300": "#8E24AA",
    "400": "#9C27B0",
    "500": "#AB47BC",
    "600": "#BA68C8",
    "700": "#CE93D8",
    "800": "#E1BEE7",
    "900": "#F3E5F5",
    A100: "#AA00FF",
    A200: "#D500F9",
    A400: "#E040FB",
    A700: "#EA80FC"
  },
  seafoamTeal: {
    "50": "#042529",
    "100": "#074A52",
    "200": "#0B707B",
    "300": "#0F95A4",
    "400": "#53B3BE",
    "500": "#6FBFC8",
    "600": "#9FD5DB",
    "700": "#B8E0E4",
    "800": "#CFEAED",
    "900": "#E7F5F6"
  },
  skyBlue: {
    "50": "#112A47",
    "100": "#22548C",
    "200": "#2B6AB2",
    "300": "#337DD1",
    "400": "#3E98FF",
    "500": "#64ACFF",
    "600": "#84BDFF",
    "700": "#A7D0FF",
    "800": "#DBECFF",
    "900": "#ECF5FF"
  },
  slateBlueGray: {
    "50": "#0E283F",
    "100": "#273E53",
    "200": "#3F5466",
    "300": "#586A7A",
    "400": "#70808D",
    "500": "#8996A1",
    "600": "#A1ACB4",
    "700": "#BAC1C8",
    "800": "#D3D7DC",
    "900": "#EBEDEF",
    A700: "#091B2A"
  },
  sunnyYellow: {
    "50": "#453408",
    "100": "#89660F",
    "200": "#AE8212",
    "300": "#CC9816",
    "400": "#F9BA1B",
    "500": "#FAC748",
    "600": "#FBD36D",
    "700": "#FCDF96",
    "800": "#FEF2D4",
    "900": "#FEF8E9"
  }
};
export {
  tidalColorsDark
};
//# sourceMappingURL=tidalColorsDark.js.map
